<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import Vue from "vue";
const customerId = window.localStorage.getItem("customerId")
export default {
    extends: baseList,
    components: {

    },
    data() {
        return {
            table: {
                mname: "facilityRate",
                key: "id",
                url: {
                    list: "/admin/system/facilityRate/list",
                    del: "/admin/system/facilityRate"
                },
                output: false,
                // order: "createTime",
            },
            query: {
            },
            actions: [
                {
                    label: "打印",
                    // icon: "md-add",
                    onClick: this.onPrint,
                    type: "info",
                    auth: "",
                },
            ],
            menus: [
                {
                    label: "收费清单",
                    name: "listOfCharges_list",
                    auth: "",
                },
                {
                    label: "费率",
                    name: "rate_list",
                    auth: "",
                },
            ],
            filters: [
                // {
                //   label: "盘点人",
                //   KeyEnter: this.search,
                //   name: "createBy",
                //   value: "",
                //   type: "input",
                // },
                // // {
                // //   label: "负责人",
                // //   KeyEnter: this.search,
                // //   name: "maintainerId",
                // //   value: "",
                // //   type: "select",
                // //   dropList: [],
                // // },
                // {
                //   label: "盘点时间",
                //   KeyEnter: this.search,
                //   name: "",
                //   value: "",
                //   type: "contractdatetimerange",
                // },
            ],
            tableCols: [
                {
                    title: "序号",
                    type: "index",
                    width: 80,
                    align: "center",
                },
                {
                    title: "设备类型",
                    key: "facilityName",
                    minWidth: 120,
                    align: "left",
                },
                {
                    title: "月服务费",
                    key: "monthPayNumber",
                    minWidth: 200,
                    align: "left",
                    render: (h, params) => {
                        const row = params.row;
                        const text = row.monthPayNumber
                        return (
                            <span
                            >
                                {text}元
                            </span>
                        );
                    },
                },
              {
                title: "资产归属",
                key: "supplierName",
                minWidth: 120,
                align: "left",
              },
              {
                title: "折扣率",
                key: "monthPayNumber",
                minWidth: 200,
                align: "left",
                render: (h, params) => {
                  const row = params.row;
                  const text = row.rateMouth ? row.rateMouth : 100
                  return (
                      <span
                      >
                                {text}%
                            </span>
                  );
                },
              },

            ],
        };
    },
    created() {
        this.query.customerId = Number(customerId) === 0 ? window.localStorage.getItem("customerIdClick") : Number(customerId)
        if (Number(customerId) === 0) {
            this.actions.push({
                label: "新增",
                icon: "md-add",
                onClick: this.toAdd,
                type: "info",
                auth: "",
            })
            this.tableCols.push({
                title: "操作",
                align: "center",
                width: 210,
                key: "handle",
                fixed: "right",
                handle: [
                    (vm, h, currentRow, param) => {
                        // let directives = []
                        return (
                            <Button
                                size="small"
                                onClick={() => this.toinfo(currentRow)}
                                type="default"
                                style={{
                                    border: "none",
                                    color: "#4991ff", margin: "0",
                                }}
                            >
                                编辑
                            </Button>
                        );
                    },
                    "delete"
                ],
                auth: {
                    // edit: "system/knowledgeBaseTag/edit",
                    // del: "system/inspection/delete",
                },
            },)
        }
    },
    methods: {
        onPrint() {
            let q = this.query
            let customerNameStr = Number(customerId) === 0 ? window.localStorage.getItem('customerNameClick') : window.localStorage.getItem("customerName")
            $utils.api.load("/admin/system/facilityRate/list", q, 'get').then(res => {
              let list = res.rows.map((item)=>({
                facilityName:item.facilityName?item.facilityName:"",
                monthPayNumber:item.monthPayNumber,
                supplierName:item.supplierName?item.supplierName:"",
                rateMouth:item.rateMouth?item.rateMouth+"%":"100%",
              }))
                printJS({
                    printable: list,
                    properties: [
                        { field: 'facilityName', displayName: '设备类型' },

                        { field: 'monthPayNumber', displayName: '月服务费（元）' },
                      { field: 'supplierName', displayName: '资产归属' },
                      { field: 'rateMouth', displayName: '折扣率' },
                    ],
                    header: customerNameStr + " 收费费率表",
                    headerStyle: `
                    font-weight:800;
                    font-size:18px;
                    text-align: center;
                    `,
                    gridHeaderStyle: "border:none;",
                    gridStyle: "border:none",
                    style: `
                        th{
                        font-size:14px;
                        border-bottom: 1px solid #999 !important;
                        padding: 10px 0;
                        }
                        td{
                        font-size:14px;
                        border-bottom: 1px solid #999 !important;
                        padding: 10px 0;
                        text-align:center;
                        }
                        td:nth-last-child(1){
                        text-align: center;
                        } 
                        th:nth-last-child(1){
                        text-align: center !important;
                        }`,
                    type: 'json'
                })
            })

        },
        //查询维修员
        loaduserData() {
            // 通过pk查询字典数据
            let q = {};
            $utils.api.load("/admin/system/maiUser/lista", q).then((res) => {
                if (res && res.rows) {
                    let ll = res.rows;
                    let dropList = [];
                    for (let index = 0; index < ll.length; index++) {
                        const element = ll[index];
                        let xx = {};
                        xx.value = element.id;
                        xx.name = element.nickName;
                        xx.children = element.children || [];
                        dropList.push(xx);
                    }
                    for (let index = 0; index < this.filters.length; index++) {
                        const element = this.filters[index];
                        if (element && element.name == "maintainerId") {
                            // this.items[index]['dropList'] = dropList
                            this.filters[index]["dropList"] = (
                                this.filters[index]["dropList"] || []
                            ).concat(dropList);
                        }
                    }
                }
            });
        },
        toAdd() {
            $utils.url.push({ name: "edit_rate", query: { action: "add" } });
        },
        toinfo(row) {
            $utils.url.push({
                name: "edit_rate",
                query: { action: "edit", kv: row.id, facilityTypeId: row.facilityTypeId },
            });
        },
    },
};
</script>
<style scoped></style>
